// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ShareCartApiParameter, shareCartService } from "@werner/App/Services/ShareCartService";

type Parameter = ShareCartApiParameter & HasOnSuccess & HasOnError<unknown>;

type HandlerType = Handler<
    Parameter,
    {
        error?: unknown;
        apiParameter: ShareCartApiParameter;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestApi: HandlerType = async props => {
    try {
        await shareCartService(props.apiParameter);
    } catch (error) {
        props.error = error;
    }
};

export const DispatchOnSuccessShareCart: HandlerType = props => {
    if (!props.error) {
        props.parameter.onSuccess?.();
    }
};
export const DispatchOnErrorShareCart: HandlerType = props => {
    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, RequestApi, DispatchOnSuccessShareCart, DispatchOnErrorShareCart];

const shareCart = createHandlerChainRunner(chain, "ShareCart");
export default shareCart;
